export const UI_LANGUAGE_COOKIE = 'uiLanguage';
export const OVERALL_MAX_SCORE_WEIGHT_AMOUNT = 100;
export const AVAILABLE_LANGUAGES = ['en', 'he', 'ar'];
export const MODAL_PORTAL_ID = 'modal-portal';
